/* eslint-disable no-undef */
'use strict';

function param(expected) {
  var url = decodeURIComponent(window.location.search.substring(1));
  var variables = url.split('&');
  var parameter;

  for (var i = 0; i < variables.length; i++) {
    parameter = variables[i].split('=');

    if (parameter[0] === expected) {
      return parameter[1] === undefined ? true : parameter[1];
    }
  }

  return null;
}

/**
 * Add all query parameters from the specified object to the location.search
 * string, and return the updated location.search string
 *
 * @param params
 *
 * @returns string
 */
function addParams(params) {
  var search = decodeURIComponent(window.location.search.substring(1));
  var variables = search ? search.split('&') : [];

  // update existing parameters if there are matches
  var newSearch = variables.map((variable) => {
    var keyValue = variable.split('=');
    var key = keyValue[0];
    var value = keyValue[1];

    if (params.hasOwnProperty(key)) {
      value = params[key];
      delete params[key];
    }

    return `${key}=${encodeURIComponent(value)}`;
  });

  // add all remaining new parameters to the search
  Object.keys(params).forEach((key) => {
    newSearch.push(`${key}=${encodeURIComponent(params[key])}`);
  });

  return `?${newSearch.join('&')}`;
}

function getParam(param) {
  if (window.location.href.indexOf(param) > -1) {
    return getUrlVars()[param];
  }
}

/**
 * Filter the search string to only contain specified keys
 *
 * @param keys
 * @returns string
 */
function getBookingShortcut(keys) {
  var search = decodeURIComponent(window.location.search.substring(1));
  var variables = search ? search.split('&') : [];

  var newSearch = variables.filter((variable) => {
    var keyValue = variable.split('=');

    return !keys.includes(keyValue[0]);
  });

  return newSearch.join('&');
}

/**
 * Check if the search string contain all specified keys
 *
 * @param keys
 * @returns bool
 */
function hasAllParams(keys) {
  var search = decodeURIComponent(window.location.search.substring(1));
  var variables = search
    ? search.split('&').map(variable => variable.split('=')[0])
    : [];

  return keys.every(key => variables.includes(key));
}

function getUrlVars() {
  // the parameter to slice() is to remove the '?' at the start of the query string
  var vars = window.location.search.slice(1).split('&');
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      query_string[key] = [query_string[key], decodeURIComponent(value)];
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

export default {
  param: param,
  addParams: addParams,
  getParam: getParam,
  hasAllParams: hasAllParams,
  getBookingShortcut: getBookingShortcut,
};
